export default "__VITE_ASSET__B6svV2Ku__"